/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Lib_Starts_In_TomorrowInputs */



/**
* | output |
* | --- |
* | "tomorrow" |
*
* @param {Tournaments_Lib_Starts_In_TomorrowInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const tournaments_lib_starts_in_tomorrow = /** @type {((inputs?: Tournaments_Lib_Starts_In_TomorrowInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Lib_Starts_In_TomorrowInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("morgen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("demain")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("明天")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("明天")
	if (locale === "ko") return /** @type {LocalizedString} */ ("내일")
	return /** @type {LocalizedString} */ ("tomorrow")
});